"use strict";
/** Cross-platform formatting helpers (web + mobile + PDF). */
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDiopter = formatDiopter;
exports.formatAxis = formatAxis;
exports.formatIop = formatIop;
exports.initials = initials;
exports.ageFromDob = ageFromDob;
/** Format a sphere/cylinder diopter value: +1.25 / -0.50 / Plano. */
function formatDiopter(value) {
    if (value === null || value === undefined)
        return "—";
    if (value === 0)
        return "Plano";
    const sign = value > 0 ? "+" : "";
    return `${sign}${value.toFixed(2)}`;
}
/** Format an axis value: 90° */
function formatAxis(value) {
    if (value === null || value === undefined)
        return "—";
    return `${value}°`;
}
/** Format intraocular pressure: 16 mmHg */
function formatIop(value) {
    if (value === null || value === undefined)
        return "—";
    return `${value} mmHg`;
}
function initials(name) {
    return name
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((p) => p[0]?.toUpperCase() ?? "")
        .join("");
}
function ageFromDob(dob) {
    const d = typeof dob === "string" ? new Date(dob) : dob;
    const now = new Date();
    let age = now.getFullYear() - d.getFullYear();
    const m = now.getMonth() - d.getMonth();
    if (m < 0 || (m === 0 && now.getDate() < d.getDate()))
        age--;
    return age;
}
//# sourceMappingURL=format.js.map